import type { CSSProperties, ReactNode } from "react";
import MediaFrame from "./MediaFrame";
export const CONTACT_EMAIL = "damo@dk-mba.com";
import founder from "@/assets/damian-keyes-founder.png";

export const mailto = `mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent("Discussing an opportunity")}`;
export const d = (ms: number) => ({ "--ed-delay": `${ms}ms` }) as CSSProperties;

/** Masked line for headline entrances; the parent carries the accessible label. */
export const Line = ({ children, i }: { children: ReactNode; i: number }) => (
  <span className="ed-line" aria-hidden><span style={{ "--i": i } as CSSProperties}>{children}</span></span>
);

/** Chapter folio: number + name, the page's one recurring navigational device. */
export const Folio = ({ n, label }: { n: string; label: string }) => (
  <p data-reveal className="ed-folio"><span>{n}</span>{label}</p>
);

export const CtaButton = ({ className = "" }: { className?: string }) => (
  <a href={mailto} className={`ed-btn ${className}`}>Discuss an Opportunity <span aria-hidden className="ed-arrow">&rarr;</span></a>
);

const SPECS = ["Institutional Development", "Student Recruitment & Growth", "Artist Development & Music Marketing"];

/* 01 — Introduction: portrait and offer as one two-column spread */
export const IntroChapter = () => (
  <section id="introduction" className="ed-section in">
    <div className="ed-wrap ed-grid in-grid">
      <div className="in-portrait">
        <MediaFrame src={founder} alt="Damian Keyes" ratio="4 / 5" slot="Damian — portrait" spec="4:5" position="center 18%" dark />
      </div>
      <div className="in-copy">
        <Folio n="01" label="Introduction" />
        <p data-reveal style={d(40)} className="ed-kicker mt-6">Damian Keyes — Entrepreneur. BIMM Co-Founder. Creative Education &amp; Music Industry Expert.</p>
        <h1 data-lines className="ed-display mt-6" aria-label="Building creative businesses. Developing the next generation of talent.">
          <Line i={0}>Building creative</Line>
          <Line i={1}>businesses. Developing</Line>
          <Line i={2}>the next generation</Line>
          <Line i={3}>of talent.</Line>
        </h1>
        <div className="in-text">
          <p data-reveal className="ed-lead">
            From co-founding BIMM to building a global online education platform and an international music marketing business, I've spent my career at the intersection of education, entrepreneurship, marketing and artist development.
          </p>
          <p data-reveal style={d(80)} className="ed-body ed-muted">
            Today, I bring that experience to educational institutions, investors, record labels and creative industry organisations looking to build, expand and grow.
          </p>
        </div>
        <ul className="in-specs" aria-label="Specialisms">
          {SPECS.map((s, i) => <li key={s} data-reveal style={d(120 + i * 60)}>{s}</li>)}
        </ul>
        <div data-reveal style={d(320)} className="in-cta">
          <CtaButton />
          <a href="#founder" className="ed-inline ed-label">Read the story</a>
        </div>
      </div>
    </div>
  </section>
);
